export default __webpack_public_path__ + "static/media/texture.a3b7a3f8.png";